const checkNotice = () => {
  var notice_container = $('#notice-container')
  notice_container.load(notice_container.data('source'));
}

export default checkNotice;
